<div class="loading" *ngIf="!video">
  <mtg-spinner></mtg-spinner>
</div>
<ng-container *ngIf="video && video.length > 0">
  <div class="header">
    <div class="title">Прямые эфиры</div>
    <div class="right">
      <div class="navigation" *ngIf="dataSliderComponent && dataSliderComponent.showArrows">
        <a href="javascript:;" (click)="dataSliderComponent.slideLeft()"><mtg-svg-icon icon="icons-arrow-left"></mtg-svg-icon></a>
        <a href="javascript:;" (click)="dataSliderComponent.slideRight()"><mtg-svg-icon icon="icons-arrow-right"></mtg-svg-icon></a>
      </div>
    </div>
  </div>

  <div class="slider">
    <mtg-spinner *ngIf="false"></mtg-spinner>
    <mtg-data-slider #dataSliderComponent>
      <mtg-data-slider-item *ngFor="let item of video">
        <a href="javascript:;" (click)="openVideoPopup(item)">
          <div class="live"><div class="dod"></div> LIVE</div>
          <img [src]="item.videoPreview.path">
          <div class="overlay">
            <div class="play"></div>
          </div>
        </a>
      </mtg-data-slider-item>
    </mtg-data-slider>
  </div>
</ng-container>
